module.exports = {"svg":{"$":{"t":"1542714709154","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"1804","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M792.413 511.827l-48.763-48.793-0.209 0.207L280.35 0.112l-48.763 48.763 463.096 463.126-463.096 463.13 48.763 48.757 512.062-512.061z m0 0z","p-id":"1805"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/right.svg
// module id = Gns9
// module chunks = 2